// The few translations the JavaScript needs, in the user's locale. The layout
// puts them into window.I18n (ApplicationHelper#javascript_i18n).
const { locale, translations } = window.I18n

export default {
  locale,
  t: (key) => translations[key]
}
